export const getCoDriverEventReassignment = (originalData) =>
  originalData?.coDriverEventReassignment;

export const isReassignmentEnabled = (meta) => meta?.enabled === true;

export const hasCoDrivers = (meta) => Object.keys(meta?.coDrivers || {}).length > 0;

export const isEligibleDrivingEntry = (entry, meta) =>
  entry?.status === 'DRIVING' && isReassignmentEnabled(meta) && hasCoDrivers(meta);

export const mapCoDriversToOptions = (coDrivers = {}) =>
  Object.keys(coDrivers).map((key) => ({
    label: coDrivers[key],
    value: key,
  }));

const normalizeDriverId = (driverId) => {
  if (driverId == null || driverId === '') return null;
  if (typeof driverId === 'object') return String(driverId.value ?? driverId);
  return String(driverId);
};

export const hasDriverChangeOnEligibleEntries = (originalEntries, currentEntries, meta) => {
  if (!isReassignmentEnabled(meta)) return false;

  return originalEntries.some((originalEntry, index) => {
    if (!isEligibleDrivingEntry(originalEntry, meta)) return false;
    const currentEntry = currentEntries[index];
    if (!currentEntry) return false;
    return normalizeDriverId(originalEntry.driverId) !== normalizeDriverId(currentEntry.driverId);
  });
};

export const isWholeLogEditBlocked = (meta, pendingDriverChange = false) => {
  if (!meta) return pendingDriverChange;
  if (meta.canEditWholeLog === false) return true;
  if (meta.activeRequests?.length > 0) return true;
  return pendingDriverChange;
};

export const hasActiveReassignmentRequests = (meta) => meta?.activeRequests?.length > 0;

export const getEntryById = (entries, entryId) =>
  entries?.find((entry) => entry.id === entryId || entry.key === entryId);

export const getCurrentDriverLabel = (entry, companyDrivers = {}) => {
  const driverId = normalizeDriverId(entry?.driverId);
  if (!driverId) return '-';
  return companyDrivers[driverId] || entry?.driverFullName || driverId;
};
